document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const slider = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!slider) return;

    const nextBtn = gallery.querySelector('.slider-button--next');
    const prevBtn = gallery.querySelector('.slider-button--prev');

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.next();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.previous();
      });
    }
  });
});
